import {filter} from 'rxjs/operators';
import {Component, ElementRef, HostListener, Inject, OnInit, Renderer, ViewChild} from '@angular/core';
import {NavigationEnd, NavigationStart, Router} from '@angular/router';
import {Observable, Subscription} from 'rxjs';
import {DOCUMENT} from '@angular/platform-browser';
import {Location, PopStateEvent} from '@angular/common';
import {NavbarComponent} from './shared/shared/navbar/navbar.component';
import {select, Store} from '@ngrx/store';
import {LoadUserAction} from './authentication/store/authentication-actions';
import {AppState} from './app.store';

let lastScrollTop = 0;
const delta = 5;
const navbarHeight = 0;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  private _router: Subscription;
  private lastPoppedUrl: string;
  private yScrollStack: number[] = [];
  url: string;
  @ViewChild(NavbarComponent) navbar: NavbarComponent;
  isLoading$: Observable<number>;

  constructor( private renderer: Renderer, private router: Router,
               @Inject(DOCUMENT, ) private document: any, private element: ElementRef,
               public location: Location, private  store: Store<any>) {}

  @HostListener('window:scroll', ['$event'])
  hasScrolled() {

    const st = window.pageYOffset;
    // Make sure they scroll more than delta
    if ( Math.abs(lastScrollTop - st) <= delta ) {
      return;
    }
    const navbar = document.getElementsByTagName('nav')[0];

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st === 0 ) {
      navbar.classList.remove('nav-down');
      navbar.classList.remove('nav-up');
    } else if (st > lastScrollTop && st > navbarHeight ) {
      // Scroll Down
      if (navbar.classList.contains('nav-down')) {
        navbar.classList.remove('nav-down');
      }
      navbar.classList.add('nav-up');
    } else {
      // Scroll Up
      //  $(window).height()
      if ( st + window.innerHeight < document.body.scrollHeight ) {
        if (navbar.classList.contains('nav-up')) {
          navbar.classList.remove('nav-up');
          navbar.classList.add('nav-down');
        }
      }
    }

    lastScrollTop = st;
  }

  ngOnInit() {
    // Observable.create((observer) => {
    //   observer.next(1);
    //   setTimeout(() => observer.next(0), 1000);
    // });
    this.isLoading$ =
      this.store.pipe(
      select((state: AppState) => state.loading.active)
    );

    this.isLoading$.subscribe(data => console.log(data));
    this.store.dispatch(new LoadUserAction());
    const navbar = document.getElementsByTagName('nav')[0];
    if (this.location.path() !== '/sections') {
      this.location.subscribe((ev: PopStateEvent) => {
        this.lastPoppedUrl = ev.url;
      });
      this.router.events.subscribe((event: any) => {
        if (event instanceof NavigationStart) {
          if (event.url !== this.lastPoppedUrl) {
            this.yScrollStack.push(window.scrollY);
          }
        } else if (event instanceof NavigationEnd) {
          if (event.url === this.lastPoppedUrl) {
            this.lastPoppedUrl = undefined;
            window.scrollTo(0, this.yScrollStack.pop());
          } else {
            window.scrollTo(0, 0);
          }
        }
      });
    }

    this._router = this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((_: NavigationEnd) => {
      this.navbar.sidebarClose();

      this.renderer.listenGlobal('window', 'scroll', () => {
        const number = window.scrollY;
        let _location = this.location.path();
        _location = _location.split('/')[2];
        if (this.location.path() !== '/sections') {

          if (number > 150 || window.pageYOffset > 150) {
            // add logic
            navbar.classList.remove('navbar-transparent');
          } else if (_location !== 'addproduct' && _location !== 'blogposts'
            && _location !== 'discover' && _location !== 'contactus'
            && _location !== 'login' && _location !== 'register' && _location !== 'search' && this.location.path() !== '/nucleoicons') {
            // remove logic
            navbar.classList.add('navbar-transparent');
          }
        }
      });
    });

    const ua = window.navigator.userAgent;
    const trident = ua.indexOf('Trident/');
    let version;
    if (trident > 0) {
      // IE 11 => return version number
      const rv = ua.indexOf('rv:');
      version = parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }
    if (version) {
      const body = document.getElementsByTagName('body')[0];
      body.classList.add('ie-background');

    }
    this.hasScrolled();
  }


}
